import React, { useCallback, useEffect, useState } from 'react';
import { ArrowButton } from './ArrowButton';
import { MpuAdBox } from './MpuAdBox';
import { SectionHeader } from './SectionHeader';
const reels = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/hd4SRkjNBB5dQKUnoNdowT/Rectangle_61.jpg',
  title: 'WHEN COFFEE BECOMES THE UNATTAINABLE CUP'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/uW3e6NSSoLACr5XnxkkN74/Rectangle_62.jpg',
  title: 'SHAPING'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/uQp5ZEPBLVV5BXkoJBfM2D/Rectangle_63.jpg',
  title: 'TWO DUBAIS, ONE ALGORITHM'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/2ESsc3ebhpJAEU1QDipbVA/Rectangle_64.jpg',
  title: 'THE FUNNIEST CAR COMMERCIAL EVER MADE'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/mcmSxqmspBiqrkKZSiDZ3u/Rectangle_106.jpg',
  title: 'CRUNCH RAMADAN 2015 AD'
}];
const PLAY_BUTTON_SVG = 'https://cdn.magicpatterns.com/uploads/oy8QapkJ5YySfwfFaQ2ktA/Polygon_4.svg';
const MPU_IMAGE = 'https://cdn.magicpatterns.com/uploads/hiNQANwGZEdJgsmwXK7AZZ/mpu.jpg';
const GAP = 20;
function useVisibleCount() {
  const [count, setCount] = useState(5);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 640) setCount(2);else if (w < 1024) setCount(3);else setCount(5);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return count;
}
export function ReelTalk() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const visibleCount = useVisibleCount();
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % reels.length);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prev => (prev - 1 + reels.length) % reels.length);
  }, []);
  const getVisibleReels = () => {
    const visible = [];
    for (let i = 0; i < visibleCount; i++) {
      const idx = (currentIndex + i) % reels.length;
      visible.push({
        ...reels[idx],
        originalIndex: idx
      });
    }
    return visible;
  };
  const visibleReels = getVisibleReels();
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.touches[0].clientX);
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStart === null) return;
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStart - touchEnd;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextSlide();else prevSlide();
    }
    setTouchStart(null);
  };
  return <section className="site-container" style={{
    marginTop: '60px',
    marginBottom: '60px'
  }} data-id="element-220">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-[37px] items-start" data-id="element-221">
        {/* LEFT: Reels slider */}
        <div className="flex-1 min-w-0 w-full" data-id="element-222">
          {/* REEL TALK badge — centered */}
          <SectionHeader label="Reel Talk" data-id="element-223" />

          {/* Slider with overlapping arrows — padding reserves space so arrows aren't clipped */}
          <div className="relative w-full" style={{
          marginTop: '-16px',
          paddingLeft: '15px',
          paddingRight: '15px'
        }} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-224">
            {/* Reels grid */}
            <div className="w-full overflow-hidden" style={{
            borderRadius: '18.75px'
          }} data-id="element-225">
              <div className="grid w-full" style={{
              gridTemplateColumns: `repeat(${visibleCount}, 1fr)`,
              gap: `${GAP}px`
            }} data-id="element-226">
                {visibleReels.map((reel, idx) => <div key={`${currentIndex}-${idx}`} className="relative cursor-pointer w-full" style={{
                aspectRatio: '168/280',
                borderRadius: '18.75px',
                overflow: 'hidden'
              }} data-id="element-227">
                    <img src={reel.imageUrl} alt={reel.title || `Reel ${idx + 1}`} className="absolute inset-0 w-full h-full object-cover" draggable={false} data-id="element-228" />
                    <div className="absolute inset-0 flex items-center justify-center z-10" data-id="element-229">
                      <img src={PLAY_BUTTON_SVG} alt="Play" className="w-[40px] h-[40px] lg:w-[75px] lg:h-[75px]" draggable={false} data-id="element-230" />
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Left arrow */}
            <ArrowButton direction="left" onClick={prevSlide} size="sm" className="absolute top-1/2 -translate-y-1/2 left-0 lg:-left-[25px]" data-id="element-231" />

            {/* Right arrow */}
            <ArrowButton direction="right" onClick={nextSlide} size="sm" className="absolute top-1/2 -translate-y-1/2 right-0 lg:-right-[25px]" data-id="element-232" />
          </div>
        </div>

        {/* RIGHT: MPU Ad in gray box — centered on mobile/tablet */}
        <MpuAdBox src={MPU_IMAGE} className="flex-shrink-0 self-start mx-auto lg:mx-0 mt-[17px]" data-id="element-233" />
      </div>
    </section>;
}